<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/')"></span>
    </div>
    <div class="title">请选择搬家规模</div>
    <!-- <img class="prepay-img" src='../../assets/img/other/prepay-amount.png'> -->
    <br>
    <div class="main">
      <div class="btn-long btn1 no-margin-top" @click="orderUpdate('move_scale','1','/move-step2?fromScale=1')">
        <!-- <div>个人搬家  <span class="event-bg">📦 物料限时免费</span> </br><span class="btn-intro">适合行李、小件家具搬运 </span></div> -->
        <div>个人搬家</br><span class="btn-intro">适合行李、小件家具搬运 </span></div>
        <div class="badge" v-show="Object.keys(orderStats).length>0">最近{{orderStats['1556849081']}}人下单</div>
      </div>
      <div class="btn-long btn2" @click="orderUpdate('move_scale','2','/move-step2?fromScale=1')">
        <div>小型整屋搬家<br><span class="btn-intro">适合Studio或两房一厅整屋搬家</span></div>
        <div class="badge" v-show="Object.keys(orderStats).length>0">最近{{orderStats['1556849088']}}人下单</div>
      </div>
      <div class="btn-long btn3" @click="orderUpdate('move_scale','3','/move-step2?fromScale=1')">
        <div>大型整屋搬家<br><span class="btn-intro">适合三房一厅或以上的整屋搬家</span></div>
        <div class="badge" v-show="Object.keys(orderStats).length>0">最近{{orderStats['1556849093']}}人下单</div>

      </div>
      <div class="btn-long btn4" @click="goto('/move-business-intro')" v-if="!ifEditing">
        <div>商业搬运<br><span class="btn-intro">到家提供专业商业搬运</span></div>
        <div class="badge" v-show="Object.keys(orderStats).length>0">专业定制服务</div>
      </div>
    </div>
    <img :src="pixelURL('move','guimo')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'step1',
  data () {
    return {
      ifEditing:false,
      orderStats:{},
      order:{
        service:'move',
        data:{
          move_scale: "",
          move_valuables: [],
          pathway_address:[],
          move_car: "",
          move_out_name: "",
          move_out_phone: "",
          move_out_street: "",
          move_out_suburb: "",
          move_out_state: "NSW",
          move_out_postcode: "",
          move_out_floor: "",
          move_out_parking: "",
          move_in_name: "",
          move_in_phone: "",
          move_in_street: "",
          move_in_suburb: "",
          move_in_state: "NSW",
          move_in_postcode: "",
          move_in_floor: "",
          move_in_parking: "",
          service_date: "",
          service_period: "",
          move_other_valuables: "",
          agency: "",
          msg:"",
          insurance_amount:0,
          coupon_id:"",
          coupon_title:"",
          couponLocked:"",
          couponValue:0,
        },
        temp:{
          isAM:'',
          isPM:'',
          isDate:'',
          timeTable:{}
        },
      }
    }
  },
  created: function () {
    //如果LS存在老的下单信息
    if (localStorage.savedMove){
      //如果LS不存在order字段，则将老下单信息覆盖LS的order字段
      if(!localStorage.order){
        localStorage.order = localStorage.savedMove;
      }//如果LS存在order字段，判断其是否属于当前服务类型：如果否，则将老下单信息覆盖LS的order字段
      if(localStorage.order){
        let localParsed = JSON.parse(localStorage.order);
        if(localParsed.service != "move"){
          localStorage.order = localStorage.savedMove;
        }
      }
    }
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "move"){
        this.order = localParsed;
      }
    }
    if (localStorage.isEditing) {
      this.ifEditing = true;
    }
    if (localStorage.orderStats) {
      this.orderStats = JSON.parse(localStorage.orderStats);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.btn-long{
  width: 85%;
  height: 96px;
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  border-radius: 5px;
  font-size: 1.2em;
  margin: 0 auto;
  margin-top: 26px;
  padding-left:6vw;
  box-sizing:border-box;
  text-align:left;
  font-weight:bold;
  position:relative;
}

.btn-intro{
  font-size:0.7em;
  font-weight:normal;
}


.badge{
  position:absolute;
  top:-10px;
  right:0;
  box-sizing:border-box;
  background:$color-orange;
  background-image: linear-gradient(90deg, #fb6835 0%, #fe7444 100%);
  padding:3px 12px;
  font-size:12px;
  color:#fff;
  -webkit-border-radius: 10px;
  -webkit-border-top-left-radius: 0;
  -webkit-border-bottom-right-radius: 0;
  -moz-border-radius: 10px;
  -moz-border-radius-topleft: 0;
  -moz-border-radius-bottomright: 0;
  border-radius: 10px;
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
}

.no-margin-top{
  margin-top:0;
}

.btn1{
  background: rgb(255,190,68);
  background:url('../../assets/img/move/scale1.svg') center right no-repeat,linear-gradient(90deg, #FFBE44 0%,#FBDD88 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(255,190,68,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(255,190,68,0.8);
  box-shadow: 0 10px 16px -10px rgba(255,190,68,0.8);
}

.btn2{
  background: rgb(255,128,154);
  background:url('../../assets/img/move/scale2.svg') center right no-repeat,linear-gradient(90deg, #FF809A 0%,#FFAC7F 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(255,128,154,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(255,128,154,0.8);
  box-shadow: 0 10px 16px -10px rgba(255,128,154,0.8);
}

.btn3{
  background: rgb(105,205,243);
  background:url('../../assets/img/move/scale3.svg') center right no-repeat,linear-gradient(90deg, #69CDF3 0%,#87F5E3 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(105,205,243,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(105,205,243,0.8);
  box-shadow: 0 10px 16px -10px rgba(105,205,243,0.8);
}

.btn3{
  background: rgb(105,205,243);
  background:url('../../assets/img/move/scale3.svg') center right no-repeat,linear-gradient(90deg, #69CDF3 0%,#87F5E3 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(105,205,243,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(105,205,243,0.8);
  box-shadow: 0 10px 16px -10px rgba(105,205,243,0.8);
}

.btn4{
  background: rgb(155,182,255);
  background:url('../../assets/img/move/scale4.svg') center right no-repeat,linear-gradient(90deg, #9BB6FF 0%,#ABE0F9 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(155,182,255,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(155,182,255,0.8);
  box-shadow: 0 10px 16px -10px rgba(155,182,255,0.8);
}

.event-bg{
  background:rgba(0,0,0,0.5);
  padding:4px;
  border-radius:5px;
  font-size:0.6em;
  vertical-align: middle;
  margin-left:10px;
}

.prepay-img{
  width:100%;
}

</style>



// WEBPACK FOOTER //
// src/pages/move/step1.vue